import React, { useEffect, useRef, useState } from 'react'
import { createVisits, createTimeSpent, viewFileInDr } from '../core/_requests'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import axios from 'axios'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
import { ContentViewUI } from '../../widgets/components/ContentViewUI'
import { useParams } from 'react-router-dom'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'
import brandingConfig from '../../../../config/brandingConfig'
import { useThemeMode } from '../../../../_metronic/partials'

function FilePreview() {
  const isListenerAttached = useRef(false)

  const startTimeRef = useRef<number>()
  const visitIdRef = useRef<number>()

  const publicSessionTokenDataroomFile = localStorage.getItem('DataRoomSession')
  const { contentId } = useParams()
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const [deviceType, setDeviceType] = useState('')
  const [osType, setOsType] = useState('')
  const [city, setCity] = useState('')
  const [country, setCountry] = useState('')
  const [ipAddress, setIpAddress] = useState('')
  const { currentUser, companyId } = useAuth()

  const IPSTACK_URL = `${process.env.REACT_APP_IPSTACK_LINK}?access_key=${process.env.REACT_APP_IPSTACK_ACCESS_KEY}&format=1`

  const [fileName, setFileName] = useState<string>()
  const [email, setEmail] = useState<string>()
  const [showFileDataRoom, setShowFileDataRoom] = useState(false)

  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }

  useEffect(() => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const find = async () => {
      const locationApiData = await axios.get(IPSTACK_URL)
      setCity(locationApiData?.data.city)
      setCountry(locationApiData?.data?.country_name)
      setIpAddress(locationApiData?.data?.ip)
    }
    setDeviceType(deviceTypeView)
    setOsType(os)
    find()
    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.FilePreviewSuccessful,
        action: 'normal',
        metadata: {
          os,
          device_type: deviceType,
          email: email,
          company_id: companyId,
          user_id: currentUser?.userId,
        },
      },
    })
  }, []) // eslint-disable-line

  // useEffect(() => {
  //   if (fileName && city && country) {
  //     createVisitsOfDataRoomFile()
  //   }
  // }, [fileName, country, city]) // eslint-disable-line

  useEffect(() => {
    if (fileName) {
      startTimeRef.current = Date.now()
    }
  }, [fileName])

  const viewFileInDataRoomPublic = async (
    contentId: string | undefined,
    publicSessionTokenDataroom: string | null
  ) => {
    if (contentId! && publicSessionTokenDataroomFile) {
      try {
        const {
          data: { data, success, errors },
        } = await viewFileInDr(contentId!, publicSessionTokenDataroom!)
        if (success) {
          if (publicSessionTokenDataroomFile) {
            localStorage.setItem('DataRoomSession', publicSessionTokenDataroomFile)
          }
          setFileName(data?.contentData?.file?.name)
          setEmail(data?.publicSession?.email)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ViewPubicFileDataRoomSuccessful,
              action: 'normal',
              metadata: {
                content_id: contentId,
                email: email,
                company_id: companyId,
                user_id: currentUser?.userId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ViewPubicFileDataRoomFailed,
              action: 'normal',
              metadata: {
                content_id: contentId,
                email: email,
                company_id: companyId,
                user_id: currentUser?.userId,
                error: errors[0],
              },
            },
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    if (publicSessionTokenDataroomFile) {
      viewFileInDataRoomPublic(contentId, publicSessionTokenDataroomFile)
    }
  }, [contentId, publicSessionTokenDataroomFile]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const onTabClose = async (event: any) => {
      let timeSpent: number | undefined = undefined // Initialize timeSpent
      if (startTimeRef.current !== 0) {
        const endTime = Date.now()
        timeSpent = Math.round((endTime - startTimeRef.current!) / 1000)
      }
      if (timeSpent !== undefined && visitIdRef.current) {
        event.preventDefault()
        // Prevent closing and show a warning message
        event.returnValue = 'Do not close the tab until data is saved!'
        // Sending data to API

        // Clearing the warning message after the API call is done
        delete event['returnValue']
        await timeSpendData(timeSpent, visitIdRef.current)
      }
    }

    if (!isListenerAttached.current) {
      window.addEventListener('beforeunload', onTabClose)
      isListenerAttached.current = true
    }

    return () => {
      if (isListenerAttached.current) {
        window.removeEventListener('beforeunload', onTabClose)
        isListenerAttached.current = false
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  //Create visit API
  const createVisitsOfDataRoomFile = async () => {
    try {
      if (deviceType && osType && city && country && contentId && publicSessionTokenDataroomFile) {
        const {
          data: { data, success, errors },
        } = await createVisits(
          deviceType,
          osType,
          city,
          country,
          ipAddress,
          contentId!,
          email,
          publicSessionTokenDataroomFile
        )
        if (success) {
          visitIdRef.current = data?.visitId
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.FileVisitedDataRoomSuccessful,
              action: 'normal',
              metadata: {
                content_id: contentId,
                device_type: deviceType,
                os_type: osType,
                city,
                country,
                email,
                company_id: companyId,
                user_id: currentUser?.userId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.FileVisitedDataRoomFailed,
              action: 'normal',
              metadata: {
                content_id: contentId,
                device_type: deviceType,
                os_type: osType,
                city,
                country,
                email,
                company_id: companyId,
                user_id: currentUser?.userId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const timeSpendData = async (timeSpent: number, visitId: number) => {
    try {
      if (timeSpent && visitId) {
        const {
          data: { success, errors },
        } = await createTimeSpent(timeSpent, visitId)
        if (success) {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.FileTimeSpendDataRoomSuccessful,
              action: 'normal',
              metadata: {
                time_spent: timeSpent,
                visit_id: visitId,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.FileTimeSpendDataRoomFailed,
              action: 'normal',
              metadata: {
                time_spent: timeSpent,
                visit_id: visitId,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div>
      {fileName && (
        <>
          <>
            <div className='py-1 mx-4'
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <img
                src={mode === 'dark' ? brandingConfig.lightModeLogo
                  : brandingConfig.lightModeLogo
                }
                height={30}
                alt={formatMessage({ id: 'recordskeeper-logo-Logo' })}
              />
              <div>
                <p className='mt-2 mb-0'>
                  <ToolTipUI tooltipText={`File`} />
                </p>
              </div>
            </div>
            <div
              style={{
                height: '1px',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                margin: '0 1rem',
              }}
            ></div>
            <ContentViewUI
              fileName={fileName}
              sessionToken={publicSessionTokenDataroomFile!}
              contentId={contentId}
            />
          </>
          {!showFileDataRoom && (
            <div className='blur-container'>
              <BasicButton
                height='44px'
                border='1px solid #4776E6'
                color='#4776E6'
                textColor='white'
                padding='12px 24px'
                onClick={() => {
                  setShowFileDataRoom(true)
                  createVisitsOfDataRoomFile()
                }}
                buttonText='Click to view file'
                minWidth={56}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default FilePreview
